import { ActionReducerMap } from '@ngrx/store';
import { eventsReducer } from 'src/app/features/social/events/data/state/events.reducer';
import { fuelReducer } from 'src/app/features/maintain/fuel/data/state/fuel.reducer';
import { mileageReducer } from 'src/app/features/maintain/mileage/data/state/mileage.reducer';
import { vanReducer } from 'src/app/features/maintain/vans/data/state/van.reducer';
import { packingListsReducer } from 'src/app/features/plan/packing-lists/data/state/packing-lists.reducer';
import { AppState } from './app.state';
import { userReducer } from './user/user.reducer';

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  van: vanReducer,
  events: eventsReducer,
  fuel: fuelReducer,
  mileage: mileageReducer,
  packingLists: packingListsReducer,
};
